import AxiosClient from "../AxiosClient";

export const postAvailableCommodityOwnersApi = (param) => {
  return AxiosClient.post(
    "/api/billing/salesPartitionSetting/getAvailableCommodityOwners",
    param
  );
}